module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_87-dc5dbfd1fbe629ccefbc25348c361b9a.png";